import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/admin/AuthContext";
import Login from "@/admin/Login";
import Layout from "@/admin/Layout";
import Overview from "@/admin/pages/Overview";
import Enquiries from "@/admin/pages/Enquiries";
import Waitlist from "@/admin/pages/Waitlist";
import ContentEditor from "@/admin/pages/ContentEditor";
import Account from "@/admin/pages/Account";
import Audit from "@/admin/pages/Audit";
import { Spinner } from "@/admin/ui";

const Gate = () => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen bg-[#0B1528]"><Spinner /></div>;
  if (!user) return <Login />;
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Overview />} />
        <Route path="enquiries" element={<Enquiries />} />
        <Route path="waitlist" element={<Waitlist />} />
        <Route path="content" element={<ContentEditor />} />
        <Route path="account" element={<Account />} />
        <Route path="audit" element={<Audit />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Route>
    </Routes>
  );
};

export default function AdminApp() {
  return (
    <AuthProvider>
      <Gate />
    </AuthProvider>
  );
}
